import {graphql} from 'react-relay';
import McpAuthorize from './McpAuthorize';

export const mcpAuthorizeQuery = graphql`
	query McpAuthorizeRoute_Query {
		viewer {
			actualPersonId
		}
	}
`;

export default McpAuthorize;
